import { createSelector } from 'reselect';

import { selectDigitalReloadProducts } from 'common/features/store/duck/brands/duck';
import { getEGiftReloadability, EGiftReloadability } from 'common/domain/reloadable';
import { Card } from 'common/api/e-comm/models/Card';
import { Product } from 'common/api/e-comm/models/Product';

/** Return type of `selectEGiftReloadability`: resolves any card's eGift reloadability. */
export type EGiftReloadabilityOf = (card: Pick<Card, 'brandId'>) => EGiftReloadability<Product>;

// Function-returning selector so cards outside cardsByUser (archived, PDP) resolve by brandId.
export const selectEGiftReloadability = createSelector(
    selectDigitalReloadProducts,
    (digitalById): EGiftReloadabilityOf =>
        (card) =>
            getEGiftReloadability(digitalById[card.brandId])
);
